"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _loglevel = _interopRequireDefault(require("loglevel"));

var _package = _interopRequireDefault(require("../../../package.json"));

var _portal = _interopRequireDefault(require("../../portal/services/portal"));

var _uiConfig = _interopRequireDefault(require("../../ui-config/services/uiConfig"));

var MODULE_NAME = 'sdk/uc-license/services/ucLicense';

var logger = _loglevel.default.getLogger(MODULE_NAME);

var UC_LICENSE_EXPIRED = 'UC_LICENSE_EXPIRED';
/**
 *
 * @returns {Promise}
 */

var hasAccess = function hasAccess() {
  logger.info("".concat(MODULE_NAME, " - hasAccess called"));
  return new Promise(function (resolve, reject) {
    _portal.default.ucCheck().then(function () {
      resolve(true);
    }).catch(function (err) {
      if (err !== false) {
        reject(err);
      } else {
        reject(UC_LICENSE_EXPIRED);
      }
    });
  });
};
/**
 *
 * @returns {Promise}
 */


var ucLicenseNotice = function ucLicenseNotice() {
  logger.info("".concat(MODULE_NAME, " - ucLicenseNotice called"));
  var message = _package.default.config.configMapping.ucLicenseNotice.default;
  return _uiConfig.default.get({
    configName: _package.default.config.configMapping.ucLicenseNotice.name,
    returnFirst: true
  }).then(function (res) {
    if (res) {
      return res.config_value;
    }

    return message;
  });
};

var _default = {
  UC_LICENSE_EXPIRED: UC_LICENSE_EXPIRED,
  hasAccess: hasAccess,
  ucLicenseNotice: ucLicenseNotice
};
exports.default = _default;
module.exports = exports.default;